"use strict";
/**
 * Subject → colour + Lucide icon palette.
 *
 * Colours are Okabe–Ito-inspired to remain distinguishable under the most
 * common forms of colour-blindness. Every subject is also paired with a
 * Lucide icon so the UI never relies on colour alone.
 *
 * High-contrast theme (WCAG AAA) flips every subject to black-on-yellow;
 * consumers pick from `light`, `dark`, or `highContrast` per the active
 * theme store.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SUBJECT_THEME = void 0;
exports.getSubjectPalette = getSubjectPalette;
exports.SUBJECT_THEME = {
    english: {
        icon: 'BookOpenText',
        light: '#4F46E5',
        dark: '#818CF8',
        highContrast: '#000000',
        highContrastBg: '#FFD900',
        tailwindFamily: 'indigo',
    },
    maths: {
        icon: 'Calculator',
        light: '#059669',
        dark: '#34D399',
        highContrast: '#000000',
        highContrastBg: '#FFD900',
        tailwindFamily: 'emerald',
    },
    science: {
        icon: 'FlaskConical',
        light: '#0891B2',
        dark: '#22D3EE',
        highContrast: '#000000',
        highContrastBg: '#FFD900',
        tailwindFamily: 'cyan',
    },
    history: {
        icon: 'Scroll',
        light: '#B45309',
        dark: '#FBBF24',
        highContrast: '#000000',
        highContrastBg: '#FFD900',
        tailwindFamily: 'amber',
    },
    geography: {
        icon: 'Globe2',
        light: '#65A30D',
        dark: '#A3E635',
        highContrast: '#000000',
        highContrastBg: '#FFD900',
        tailwindFamily: 'lime',
    },
    re: {
        icon: 'HandHeart',
        light: '#7C3AED',
        dark: '#A78BFA',
        highContrast: '#000000',
        highContrastBg: '#FFD900',
        tailwindFamily: 'violet',
    },
    computing: {
        icon: 'MonitorSmartphone',
        light: '#0284C7',
        dark: '#38BDF8',
        highContrast: '#000000',
        highContrastBg: '#FFD900',
        tailwindFamily: 'sky',
    },
    art_design: {
        icon: 'Palette',
        light: '#DB2777',
        dark: '#F472B6',
        highContrast: '#000000',
        highContrastBg: '#FFD900',
        tailwindFamily: 'pink',
    },
    design_technology: {
        icon: 'Wrench',
        light: '#EA580C',
        dark: '#FB923C',
        highContrast: '#000000',
        highContrastBg: '#FFD900',
        tailwindFamily: 'orange',
    },
    music: {
        icon: 'Music2',
        light: '#9333EA',
        dark: '#C084FC',
        highContrast: '#000000',
        highContrastBg: '#FFD900',
        tailwindFamily: 'purple',
    },
    pe: {
        icon: 'Dumbbell',
        light: '#DC2626',
        dark: '#F87171',
        highContrast: '#000000',
        highContrastBg: '#FFD900',
        tailwindFamily: 'red',
    },
    mfl: {
        icon: 'Languages',
        light: '#0D9488',
        dark: '#2DD4BF',
        highContrast: '#000000',
        highContrastBg: '#FFD900',
        tailwindFamily: 'teal',
    },
    pshe: {
        icon: 'ShieldCheck',
        light: '#D97706',
        dark: '#FCD34D',
        highContrast: '#000000',
        highContrastBg: '#FFD900',
        tailwindFamily: 'amber',
    },
};
function getSubjectPalette(subject) {
    return exports.SUBJECT_THEME[subject];
}
